import { render } from "./SettingsDropdown.vue?vue&type=template&id=405d6244"
import script from "./SettingsDropdown.vue?vue&type=script&lang=js"
export * from "./SettingsDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script